import { format, fromUnixTime, isValid, parseISO } from 'date-fns';

const STORAGE_KEY = 'ds-changelog-seen-id';
export const CHANGELOG_SEEN_EVENT = 'ds-changelog-seen';

export function formatReleasedAt(value) {
    if (value == null || value === '') {
        return '';
    }

    try {
        let date;

        if (typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(value))) {
            const timestamp = Number(value);
            date = timestamp < 1e12 ? fromUnixTime(timestamp) : new Date(timestamp);
        } else {
            date = parseISO(String(value));
        }

        return isValid(date) ? format(date, 'dd.MM.yyyy') : '';
    } catch (error) {
        return '';
    }
}

export function getSeenId() {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);

        if (raw === null || raw === '') {
            return null;
        }

        const id = Number(raw);

        return Number.isFinite(id) ? id : null;
    } catch (error) {
        return null;
    }
}

export function markSeen(id) {
    if (id == null) {
        return;
    }

    try {
        window.localStorage.setItem(STORAGE_KEY, String(id));
    } catch (error) {
        // Private mode / blocked storage — still notify listeners.
    }

    window.dispatchEvent(new CustomEvent(CHANGELOG_SEEN_EVENT, { detail: { id } }));
}

export function isUnseen(entry) {
    if (!entry || entry.id == null) {
        return false;
    }

    const seen = getSeenId();

    return seen === null || seen !== entry.id;
}
